import * as React from 'react';

const SVGComponent = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={29} height={29} {...props}>
    <g data-name="Group 2362" transform="translate(-222 -508)">
      <rect
        data-name="Rectangle 835"
        width={29}
        height={29}
        rx={10}
        transform="translate(222 508)"
        style={{
          fill: '#1a1f3f'
        }}
      />
    </g>
    <path
      data-name="Path 5531"
      d="M1780.028 209.663h-8.478a2.561 2.561 0 0 1-2.675-2.67v-11.4a2.56 2.56 0 0 1 2.676-2.669h16.978a2.558 2.558 0 0 1 2.664 2.659V207a2.559 2.559 0 0 1-2.665 2.659zm-4.181-3.716H1779.247a.709.709 0 0 0 .786-.781v-.349a2.556 2.556 0 0 0-2.558-2.591c-1.082-.013-2.165-.01-3.247 0a2.509 2.509 0 0 0-1.966.922 2.736 2.736 0 0 0-.6 1.949c.019.591.262.851.851.851zm2.321-6.977a2.319 2.319 0 1 0-2.328 2.325 2.326 2.326 0 0 0 2.328-2.325zm6.965-1.857h-2.463a.7.7 0 1 0 .008 1.393h4.947a.7.7 0 1 0-.008-1.393zm.008 5.108h2.506a.7.7 0 1 0 .014-1.39c-1.678 0-3.355-.006-5.033.005a.91.91 0 0 0-.463.153.658.658 0 0 0-.234.757.683.683 0 0 0 .662.473c.849.005 1.698.002 2.548.002zm.012 2.334h-2.506a.682.682 0 0 0-.748.675.69.69 0 0 0 .737.715q2.506.007 5.012 0a.926.926 0 0 0 .4-.095.688.688 0 0 0-.32-1.291c-.861-.008-1.718-.003-2.575-.003z"
      transform="translate(-1765.534 -185.796)"
      style={{
        fill: '#fff'
      }}
    />
  </svg>
);

export default SVGComponent;
